export default "__VITE_ASSET__DIwN9UKu__"